<template>
  <section class="notFoundCnt">
    <div class="notFound">
      <img src="../assets/not-found.png">
      <h4>404</h4>
      <h2 v-if="lang === 'id'">Tidak Ditemukan</h2>
      <h2 v-if="lang === 'en'">Not Found</h2>
      <p v-if="lang === 'id'">Kami tidak dapat menemukan halaman yang kamu cari</p>
      <p v-if="lang === 'en'">We can't find the page you looking for</p>
      <a :href="`${$config.appPath}${langCode}`" class="btn secondary">
        <template v-if="lang === 'id'">Halaman Utama</template>
        <template v-else>Back To Home</template>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'notFound',
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {},
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss"></style>
